module.exports = __webpack_public_path__ + "img/11.c3da1aed.jpg";